import { EntityImageManager } from '@/components/entity-image-manager';
import { useSubscription } from '@/hooks/useSubscription';
import type { Location, ProcessedImage } from '@/lib/types';

interface ImageManagerProps {
  onUpdate: (updates: { images?: ProcessedImage[], pendingFiles?: File[], primaryImageId?: string | null }) => void;
  location: Partial<Location> & { id?: string };
  pendingFiles?: File[];
  isProcessing?: boolean;
  visualDescription?: string;
  onVisualDescriptionChange?: (value: string) => void;
  entityId?: string; // Explicitly pass for new entities
  disableDeletion?: boolean;
}

export function ImageManager({
  onUpdate,
  location,
  pendingFiles,
  isProcessing = false,
  visualDescription,
  onVisualDescriptionChange,
  entityId: explicitEntityId,
  disableDeletion
}: ImageManagerProps) {
  const { hasFeature, isTokenDepleted } = useSubscription();
  const canCreateAIImages = hasFeature('can_create_ai_images');

  return (
    <EntityImageManager
      type="locations"
      images={location.images || []}
      primaryImageId={location.primaryImageId ?? null}
      onUpdate={onUpdate}
      pendingFiles={pendingFiles}
      isProcessing={isProcessing}
      entityId={explicitEntityId || location.id || ''}
      canCreateAIImages={canCreateAIImages}
      isTokenDepleted={isTokenDepleted}
      visualDescription={visualDescription}
      onVisualDescriptionChange={onVisualDescriptionChange}
      disableDeletion={disableDeletion}
    />
  );
}
